import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2'
import { GlobalAttachmentsComponent } from 'src/app/views/directives/global-attachments/global-attachments.component';
import { Utilityservice } from 'src/app/views/utility/utilityservice.service';
import { Table } from 'primeng/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { SchedularLogService } from './schedularLog.service';
import { GlobalMessage } from '../../utility/modals';
import { Router } from '@angular/router';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import * as moment from 'moment';

@Component({
  selector: 'app-schedularLog',
  templateUrl: './schedularLog.component.html',
  styleUrls: ['./schedularLog.component.css']
})

export class SchedularLogComponent implements AfterViewInit, OnInit {
  product_data: any;
  schedule_data: any;
  schedulertype_data: any;
  status_data: any;
  from_date_data: any;
  to_date_data: any;
      
schedularlogDataExcel() {

  this.spinner.show(); // ✅ show early

  const data = {
    schedulerid: this.filterdata?.schedulerid ?? "",
    productid: this.filterdata?.productid ?? "",
    schedulertype: this.filterdata?.schedulertype ?? "",
    status: this.filterdata?.status ?? "",
    from_date: this.filterdata?.from_date 
                  ? moment(this.filterdata.from_date).format('DD-MMM-YYYY') 
                  : "",
    to_date: this.filterdata?.to_date 
                  ? moment(this.filterdata.to_date).format('DD-MMM-YYYY') 
                  : ""
  };

  this.schedularlogService.schedulerlog_data_excel(data)
    .subscribe(
      (response: Blob) => {

        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = url;
        a.download = 'Scheduler Log Data.xlsx';
        a.click();

        window.URL.revokeObjectURL(url);

        this.schedularlogModal = false;
        this.spinner.hide();

        Swal.fire('File downloaded successfully!', '', 'success');
      },
      error => {
        this.spinner.hide();
        Swal.fire('Something went wrong', '', 'error');
      }
    );
}
menu: any;
schedularlogModal=false;

index: number;

tableData: [];
commonScrollHeight: any;
bulkModal: boolean;
filedata: any;
  message: any;
  result: any;

getData(event:LazyLoadEvent){     
let page = event.first / event.rows + 1;
this.schedularlogService.filtersObservable.subscribe(res=>{    
res.page=page
res.size=event.rows;
res['filters']=event.filters;
res['sortField']=event.sortField;
res['sortOrder']=event.sortOrder;
this.filterdata=res;
this.getDataWithfilter(this.filterdata);
});
}

  @ViewChild('dt') dt: Table; 
  componantName: string = 'task';
  ref: DynamicDialogRef | undefined;
  filterdata: any
  schedularData: Array<any> = [];
  visible: boolean = false;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  isActivefilter=false
  options = [
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 30, value: 30 }
  ];
  paginatorArray
  items: MenuItem[] | undefined;
  exceldownloadModal=false;
  taskfullbackupModal=false;
  delete_modal=false;
  cols=[];
  _selectedColumns=[];
  excel_paragraph='';
  globalmessage:GlobalMessage=new GlobalMessage();
  constructor(private schedularlogService: SchedularLogService,private route:Router,public dialogService: DialogService,
    private utilityserv:Utilityservice,private elRef: ElementRef,private spinner:NgxSpinnerService, public PagehelpmodalService: PagehelpmodalService) {
      this.excel_paragraph=this.globalmessage.downloadexcel_text;

      this.utilityserv.refreshfilter.subscribe(res=>{
        if(res=='reset'){
          this.dynamiccols();
          this.isActivefilter=false
        }
      })

  }
  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isActivefilter=false;
    }
  }
  showTableColumns(){
    this.isActivefilter=!this.isActivefilter; 
  }
  ngAfterViewInit() {
    this.componantName = 'Value from parent';
  }
  showDialog() {
    this.exceldownloadModal=true;
  }
  closedpop() {
    this.visible = false
  }
  handleDialogClose() {
    this.filedata = []; 
  }    
  getselectfiles(event){
    this.filedata=event
  }
  showBulkUploadDialog() {
    this.bulkModal=true;  
  }
        todaysDate: Date = new Date();
  ngOnInit() { 
      this.commonScrollHeight=this.utilityserv.updateScrollHeight();
    //  this.getList();
      this.dynamiccols();
      // todaysDate: Date = new Date();
          // // document.getElementById("from_date").value = "2014-02-09";
          // this.filterdata.from_date = moment(this.todaysDate).format('DD-MMM-YYYY');
          // this.filterdata.to_date = moment(this.todaysDate).format('DD-MMM-YYYY');
      this.schedularlogService.refreshfilter.subscribe(res => {
        if(res!==''){
          this.filterdata = {
            productid : "",
            schedulerid : "",
            status:  "",
            schedulertype: "",
             from_date : moment(this.todaysDate).format('DD-MMM-YYYY'),
             to_date : moment(this.todaysDate).format('DD-MMM-YYYY'),
            page:1,
            size:10
          }
          this.getDataWithfilter(this.filterdata)
          // this.filedata.from_date.value="2014-02-09";
        }
      });
    }
    

  getDataWithfilter(filterdata: any) {
  this.schedularlogService.count_scheduler_data(filterdata).subscribe((data: any) => {
        if (data.length > 0) {
           this.schedularlogService.get_filtered_scheduler_data(filterdata).subscribe((data) => {
            this.tableData = data.schedulerdata;   
              this.totalRecords = data.totalcount;
              this.options = this.utilityserv.getOptionDropdown(data.totalcount);
              this.paginatorArray = this.options.map(e => e.value);            
              if (filterdata.sortField) {
                this.utilityserv.sortData(filterdata.sortField, filterdata.sortOrder,this.schedularData);
              }
              if(filterdata.filters){ 
             this.schedularData = this.utilityserv.columnFilter(filterdata,this.schedularData);
              }
              this.spinner.hide();
            },error=>{
              this.spinner.hide();
              const timestamp = new Date().toLocaleString(); // example timestamp
        Swal.fire({
          title: error.error.error,
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        })
            });
        } 
      },error=>{
        this.spinner.hide();
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error.error,
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        })
      });
}   

   currentPageIndex: number = 0;
  handlePageChange(event: any) {
    this.rows2 = event.rows;
    this.currentPageIndex = event.first;
  }

  dynamiccols(){
    this.cols=[ 
      { field: "schedulerid", header: "Scheduler ID",type:'text',sort: false , filter:false, width:'7px',isChecked:true,class:'otherheader' } ,  
      { field: "productname", header: "Product Name",type:'text',sort: false , filter:false, width:'10px',isChecked:true,class:'otherheader' } ,
      { field: "schedulerclassname", header: "Scheduler Class Name",type:'text',sort: false , filter:false, width:'10px',isChecked:true,class:'otherheader' } ,
      { field: "schedulermethodname", header: "Scheduler Method Name",type:'text',sort: false , filter:false, width:'10px',isChecked:true,class:'otherheader' } ,
      { field: "schedulername", header: "Scheduler Name",type:'text',sort: false , filter:false, width:'20px',isChecked:true,class:'otherheader' },
      { field: "schedulertype", header: "Scheduler Type",type:'text',sort: false , filter:false, width:'20px',isChecked:true,class:'otherheader' },
      { field: "status", header: "Status",type:'text',sort: false , filter:false, width:'20px',isChecked:true,class:'otherheader' } ,
      { field: "createdon", header: "Created On",type:'text',sort: false , filter:false, width:'10px',isChecked:true,class:'otherheader' } ,
      ]
   this._selectedColumns = this.cols;
  }

}



